import {ElMessageBox, ElNotification} from 'element-plus'

export default {
  install(app) {
    app.config.globalProperties.$prompt = ElMessageBox.prompt
    app.config.globalProperties.$notify = ElNotification
  },
}
